import {
  Box,
  Flex,
  Text,
  Spinner,
  useBreakpointValue
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import { Column } from "react-table";

import { Header } from "../../../components/Header";
import { Sidebar } from "../../../components/Sidebar";
import ContentBase from "../../../components/ContentBase";
import MainBase from "../../../components/MainBase";
import MainActions from "../../../components/MainActions";
import { MainTable } from "../../../components/MainTable";
import { RemoveAccent } from "../../../utils/RemoveAccent";
import { Promotion, usePromotions } from "../../../services/hooks/usePromotions";

export function PromotionsList() {
  const [searchField, setSearchField] = useState('');
  const [allPromotions, setAllPromotions] = useState<Promotion[]>([]);

  const fileName = `Lista-de-promocoes-${Date.now()}.csv`;
  const csvHeaders = [
    {
      label: 'Mensagem',
      key: 'message'
    },
    {
      label: 'Cupom',
      key: 'coupon?.code'
    },
    {
      label: 'Dia da Promoção',
      key: 'promotionDateFormatted'
    },
  ]

  const { data, isLoading, isFetching, error } = usePromotions()

  useEffect(() => {
    if (data) {
      setAllPromotions(data)
    }
  }, [data])

  const handleChangeSearch = useCallback((event) => {
    setSearchField(event.target.value)
  }, [])

  const handleSearch = useCallback(() => {
    if (data) {
      if (searchField) {
        const searchFieldWithoutAccent = RemoveAccent(searchField.toLowerCase())
        const promotionsFiltered = data.filter(
          promotion => RemoveAccent(promotion.message.toLowerCase()).match(searchFieldWithoutAccent)
        )

        setAllPromotions(promotionsFiltered)

        return
      }

      setAllPromotions(data)
    }
  }, [searchField, data])

  const handleOnPressEnter = useCallback((event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  }, [handleSearch])

  const columns: Column<Promotion>[] = [
    {
      Header: "Mensagem",
      accessor: "message",
      //  @ts-ignore TYPE NEEDS FIXING
      isSortable: true,
    },
    {
      Header: "Cupom",
      //  @ts-ignore TYPE NEEDS FIXING
      accessor: "coupon.code",
      isSortable: true,
    },
    {
      Header: "Dia da Promoção",
      accessor: "promotion_date",
      //  @ts-ignore TYPE NEEDS FIXING
      formattedValue: "promotionDateFormatted",
      isSortable: true,
    },
  ];

  const actions = [
    {
      type: 'edit',
      url: '/promotions/update/<id>',
    }
  ]

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  })

  return (
    <Flex direction="column" h="100vh">
      { !isWideVersion && <Header /> }

      <ContentBase>
        <Sidebar />

        <MainBase
          mainTitle="Destaques & Promoções"
          isLoading={isLoading}
          isFetching={isFetching}
        >
          <MainActions
            handleChangeSearch={handleChangeSearch}
            handleOnPressEnter={handleOnPressEnter}
            handleSearch={handleSearch}
            searchPlaceHolder="Digite a mensagem da promoção que deseja procurar..."
            createLink="/promotions/create"
            csvDownload={{
              csvData: allPromotions,
              csvHeaders: csvHeaders,
              csvFileName: fileName,
            }}
          />

          <Box
            w="100%"
            h={["", null, null, "80vh"]}
          >
            { isLoading ? (
              <Flex justify="center">
                <Spinner color="blue.900" size="xl" />
              </Flex>
            ) : error ? (
              <Flex direction="column">
                <Text fontSize="lg" color="blue.900">Oops...ocorreu uma falha ao obter os destaques :(</Text>
                <Text fontSize="lg" color="blue.900">Tente novamente ;)</Text>
              </Flex>
            ) : (
              <Flex
                w="100%"
                h="100%"
                direction="column"
                justifyContent="space-between"
              >
                <MainTable
                  columns={columns}
                  data={allPromotions}
                  actions={actions}
                />
              </Flex>
            )}
          </Box>
        </MainBase>
      </ContentBase>
    </Flex>
  );
}
